import React from 'react';
import { Link } from "react-router-dom";

const Header = () => {
    return (  
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary bg-gradient justify-content-between">
            <div className="container">
                <h1 className="mt-5">
                    <Link to={'/'} className="text-light">
                        ELECTRO<span>NATURAL</span>
                    </Link> 
                </h1>
            </div>
            <div className="btn-group mb-4">
                <Link 
                    to={"/proyectos/"}
                    className="btn btn-warning nuevo-post d-block de-md-inline-block"
                >Volver a Proyectos</Link>
            </div>
            
        </nav>
    );
}
 
export default Header;